import store from "store2";

const TRELLO_STORE_KEY = "TRELLO";

export const trelloStore = store.namespace(TRELLO_STORE_KEY);
